import { useState, useEffect } from 'react';

function useConfiguration(getConfiguration) {
  const [ complete, setComplete ] = useState(false);
  const [ errors, setErrors ] = useState([]);
  const [ fieldConfiguration, setFieldConfiguration ] = useState(null);

  const loadConfiguration = async () => {
    try {
      const config = await getConfiguration();
      setFieldConfiguration(config);
    } catch (error) {
      setErrors([error.message]);
    } finally {
      setComplete(true);
    }
  }

  useEffect(() => {
    loadConfiguration();
  }, []);
  return { complete, errors, fieldConfiguration }
}

export default useConfiguration;